export default __webpack_public_path__ + "static/bg-416cd614dd735d90696b54f8e0f5ed0c.png";